import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { AuthenticationResponse } from "../../Interfaces/AuthenticationResponse";
import { BCAppUser } from "../../Interfaces/BCAppUser";
import { RootState } from "../store"

// Define a type for the slice state
interface AppSliceState {
    selectedOrder: string | null;
    sharepointSite: string | null;
}
var storeState: AppSliceState = localStorage.getItem("deloof.service.appstate") ? JSON.parse(localStorage.getItem("deloof.service.appstate")!!) : null;
const emptyState: AppSliceState = {
    selectedOrder: null,
    sharepointSite: null
}
const initialState: AppSliceState = storeState ? storeState : emptyState;

export const appSlice = createSlice({
    name: 'app',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState: initialState
    ,
    reducers: {
        setSelectedOrder: (state, action: PayloadAction<string | null>) => {
            state.selectedOrder = action.payload;
        },
        setSharepointSite: (state, action: PayloadAction<string | null>) => {
            state.sharepointSite = action.payload;
            localStorage.setItem("deloof.service.appstate", JSON.stringify(state));

        },
    },
})

export const { setSelectedOrder, setSharepointSite } = appSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectApp = (state: RootState) => state.app

export default appSlice.reducer